import { Group, Pagination, Select, Text } from "@mantine/core";
import type { PaginationControlsProps } from "./types";

/**
 * Pagination controls component with items-per-page selector
 */
const PaginationControls = ({
  totalClients,
  limit,
  setLimit,
  totalPages,
  currentPage,
  setCurrentPage,
}: PaginationControlsProps) => {
  return (
    <Group justify="space-between" align="center" mb="md">
      <Group gap="sm">
        <Text size="sm" c="dimmed">
          {totalClients} client
          {(totalClients || 0) !== 1 ? "s" : ""}
        </Text>
      </Group>

      <Group gap="sm">
        <Select
          value={limit.toString()}
          onChange={(value) => setLimit(parseInt(value ?? "5"))}
          data={[
            { value: "5", label: "5 per page" },
            { value: "10", label: "10 per page" },
            { value: "25", label: "25 per page" },
            { value: "50", label: "50 per page" },
          ]}
          size="sm"
          w={120}
          data-testid="client-limit-select"
        />

        <Pagination
          color="#0077CC"
          total={totalPages ? parseInt(totalPages) : 0}
          value={currentPage}
          onChange={setCurrentPage}
          size="sm"
        />
      </Group>
    </Group>
  );
};

export default PaginationControls;
